//#region react import
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
//#endregion

//#region component import
import GstaToolTip from "../../../Components/GstaToolTip/GstaToolTip.component";
import SwitchWithText from "../../../Components/SwitchWithText/SwitchWithText.component";
//#endregion

//#region service import
import { setTrainingStepType } from "../../../Services/TrainingStepService";
//#endregion

//#region functions import
import { FORMAT_TIMESTRING, formatSecondToStringTime } from "../../../Helper/TimeConverter";
import { getTranslations } from "../../../Helper/TranslationController";
//#endregion

//#region store import
import { setErrorNotification } from "../../../ReduxStore/notificationSlice";
//#endregion

//#region constants import
import { ICON_HELP, ICON_TIMER, ICON_TRAFIC_LIGHT } from "../../../Constants/IconConstants";
import { TRANSLATIONS } from "../../../Constants/Translations";
import {
  CSS_CLASS_CIRCLE_MANDATORY,
  CSS_CLASS_CIRCLE_OPTIONAL,
  TRAINING_STEP_TYPE,
} from "./TrainingDetailStepItem.constants";
//#endregion

//#region style import
import "./TrainingDetailStepItem.style.scss";
//#endregion

const TrainingDetailStepItem = ({ step, trainingInfo }) => {
  //#region useState
  const [isMandatory, setIsMandatory] = useState(step?.mandatory);
  const [classMandatory, setClassMandatory] = useState(
    step?.mandatory ? CSS_CLASS_CIRCLE_MANDATORY : CSS_CLASS_CIRCLE_OPTIONAL
  );
  const [isVisibleSwitch] = useState((!trainingInfo.isAcreos && !trainingInfo.isArchive).toString());
  //#endregion

  //#region useSelector
  const translations = useSelector((state) => state.translationSlice.translations);
  const activeCenterId = useSelector((state) => state.connexionSlice.trainer?.activeCenter?.id);
  //#endregion

  //#region other use
  const dispatch = useDispatch();
  //#endregion

  //#region functions
  const getTypeToSet = () => {
    if (!+isMandatory) return TRAINING_STEP_TYPE.OBLIGATOIRE;
    else return TRAINING_STEP_TYPE.ENTRAINEMENT;
  };

  const handleMandatoryValue = async () => {
    await setTrainingStepType(activeCenterId, trainingInfo.id, step.id, getTypeToSet())
      .then(() => {
        setIsMandatory(!isMandatory);
        setClassMandatory(isMandatory ? CSS_CLASS_CIRCLE_OPTIONAL : CSS_CLASS_CIRCLE_MANDATORY);
      })
      .catch((error) => {
        console.error(error);
        dispatch(setErrorNotification({ message: getTranslations(TRANSLATIONS.MODIFY_STEP_TYPE_ERROR, translations) }));
      });
  };

  const orderStepExercisesBySerieNumber = () => {
    const exercises = step?.exercises;
    const result = [];

    if (exercises && Array.isArray(exercises)) {
      let currentSerieNumber = null;
      let currentGroup = null;
      let id = 1;

      exercises.forEach((exercise) => {
        const { number, serieNumber } = exercise;

        if (serieNumber !== currentSerieNumber || currentGroup === null) {
          currentGroup = {
            id: id++,
            serieNumber: serieNumber,
            exercises: [number],
          };
          result.push(currentGroup);
          currentSerieNumber = serieNumber;
        } else {
          currentGroup.exercises.push(number);
        }
      });
    }
    return result;
  };

  const renderExercisesStepDetail = () => {
    const orderedExercises = orderStepExercisesBySerieNumber();
    let tootipContent = `${getTranslations(
      TRANSLATIONS.STEP_EXERCISES_TOOLTIP_DOWLOAD,
      translations
    )} "${getTranslations(TRANSLATIONS.SIMULATION_CONTENT, translations)}" ${getTranslations(
      TRANSLATIONS.STEP_EXERCISES_TOOLTIP_THIS_SIMULATION,
      translations
    )}.`;
    return orderedExercises?.length > 0 ? (
      <div>
        <div className="step-info-description-exercices">
          <i className={ICON_TRAFIC_LIGHT} />
          <span>{getTranslations(TRANSLATIONS.STEP_EXERCISES, translations)}</span>
          <GstaToolTip toolTipContent={tootipContent}>
            <i className={ICON_HELP} />
          </GstaToolTip>
        </div>

        {orderedExercises.map((exercise) => (
          <div
            key={exercise.id}
            className="step-info-description-serie"
          >
            <span className="step-info-description-serie-title">
              {getTranslations(TRANSLATIONS.SELECT_SERIE_EXERCICE_SERIE, translations)} {exercise.serieNumber} :
            </span>
            <span>
              {getTranslations(TRANSLATIONS.EXERCISES_IN_STEP, translations)} {exercise.exercises.join(" / ")}
            </span>
          </div>
        ))}
      </div>
    ) : (
      <></>
    );
  };
  //#endregion
  return (
    <div className="cursus-step">
      <div className="circle-centered">
        <div>
          <div className={`circle ${classMandatory}`}>
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 100 100"
            >
              <text
                className="step-progress-text"
                x="50%"
                y="50%"
                dy="0.35em"
              >
                {step && step.trainingStepOrder ? step.trainingStepOrder : "-"}
              </text>
            </svg>
          </div>
        </div>
      </div>

      <div className="step-timeline">
        <div />
        <div />
      </div>
      <div className="step-info">
        <div className="step-info-header">
          <div className="step-info-header-title">
            <h3 className="title3">{step.customName ? step.customName : getTranslations(step.name, translations)}</h3>
            <SwitchWithText
              isvisible={isVisibleSwitch}
              label={getTranslations(TRANSLATIONS.PERSONNALIZED_FIELD_MANDATORY, translations)}
              onText={getTranslations(TRANSLATIONS.COMMON_YES, translations)}
              offText={getTranslations(TRANSLATIONS.COMMON_NO, translations)}
              handleChange={handleMandatoryValue}
              checked={isMandatory}
            />
          </div>
          <div className="step-info-header-extra-title">
            <div className="text-icon">
              <i className={ICON_TRAFIC_LIGHT} />
              <span>{step.exerciceCount}</span>
            </div>
            <div className="text-icon">
              <i className={ICON_TIMER} />
              <span>{formatSecondToStringTime(step.duration, translations, FORMAT_TIMESTRING.HHMM)}</span>
            </div>
          </div>
        </div>
        <p />
        <span className="step-info-description">
          {step.customDescription ? step.customDescription : getTranslations(step.description, translations)}
          {renderExercisesStepDetail()}
        </span>
      </div>
    </div>
  );
};

export default TrainingDetailStepItem;
